import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای MrpRunDetailPage

<Alert variant="info">
محتوای راهنمای این صفحه به‌زودی تکمیل خواهد شد.
</Alert>

export default Layout;
